// Formatting shared by the panel steps.

export function formatNumber(value) {
    if (value === null || value === undefined || value === '') return null;

    const number = Number(value);

    return isNaN(number) ? String(value) : number.toLocaleString();
}

export function formatMoney(value) {
    const number = formatNumber(value);

    return number === null ? null : '$' + number;
}

export function formatSqft(value) {
    const number = formatNumber(value);

    return number === null ? null : number + ' SF';
}

export function formatAcres(value) {
    return value === null || value === undefined || value === '' ? null : value + ' acres';
}

/** Two letters for the owner avatar, as the design shows them. */
export function initials(name) {
    const parts = String(name || '')
        .replace(/[^A-Za-z ]/g, ' ')
        .trim()
        .split(/\s+/);

    return ((parts[0] || '')[0] || '') + ((parts[1] || '')[0] || '');
}

// The scale bar's drawn width, from .ParcelMap-scale::before.
const SCALE_BAR_PX = 44;
// Web Mercator ground resolution at the equator at zoom 0.
const METRES_PER_PIXEL_AT_ZOOM_0 = 156543.03392;
const METRES_PER_FOOT = 0.3048;
const FEET_PER_MILE = 5280;
const LARGEST_FEET_LABEL = 1000;

/**
 * How far the scale bar reaches at this zoom and latitude, to two figures.
 * Mercator stretches with latitude, so the zoom alone cannot say.
 */
export function scaleLabel(zoom, latitude) {
    const metresPerPixel = (METRES_PER_PIXEL_AT_ZOOM_0 * Math.cos((latitude * Math.PI) / 180)) / Math.pow(2, zoom);
    const feet = (metresPerPixel * SCALE_BAR_PX) / METRES_PER_FOOT;

    if (feet < LARGEST_FEET_LABEL) return twoFigures(feet) + ' ft';

    return twoFigures(feet / FEET_PER_MILE).toLocaleString() + ' mi';
}

function twoFigures(value) {
    return Number(value.toPrecision(2));
}

export function timeOfDay(iso) {
    if (!iso) return '';

    const date = new Date(iso);

    return isNaN(date.getTime())
        ? ''
        : String(date.getHours()).padStart(2, '0') + ':' + String(date.getMinutes()).padStart(2, '0');
}
